<template>
  <button
    class="btn-link"
		type="button"
    :class="classes"
    :disabled="disabled"
    @click="onClick"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <template v-if="havePrefixIcon">
			<VIcon v-if="material" :material="material" theme="outlined"/>
			<slot v-else name="icon"/>
    </template>

    <slot v-if="haveContent" />

    <template v-if="havePostfixIcon">
			<VIcon v-if="material" :material="material" theme="outlined"/>
			<slot v-else name="icon"/>
		</template>
  </button>
</template>

<style lang="scss" src="./VLink.scss"/>

<script>
export default {
  name: "VLink",
  inheritAttrs: true,

  props: {
    /**
     * Расположить иконку после текста.
     */
    iconPostfix: {
      type:    Boolean,
      default: false,
    },
    /**
     * Контрол включен/выключен
     */
    disabled: {
      type:    Boolean,
      default: false,
    },
    /**
     * Поясняющий текст возле кнопки, содержимое тултипа
     */
    title: {
      type:    String,
      default: null,
    },
		/**
		 * Material-иконка кнопки — шорткат вместо <template #icon><VIcon material="..."/></template>.
		 * Имеет приоритет над слотом #icon: если передан material, слот игнорируется.
		 */
		material: {
			type: String,
			default: null,
		},
  },

  emits: ["click"],

  computed: {
    haveIcon() {
			return !!this.material || !!this.$slots.icon;
    },
    havePrefixIcon() {
      return this.haveIcon && !this.iconPostfix;
    },
    havePostfixIcon() {
      return this.haveIcon && this.iconPostfix;
    },
    haveContent() {
      return !!this.$slots.default;
    },
    classes() {
      return {
        "with-icon":    this.haveIcon,
        "prefix-icon":  this.haveIcon && this.haveContent && !this.iconPostfix,
        "postfix-icon": this.haveIcon && this.haveContent && this.iconPostfix,
        empty:          !this.haveContent,
      };
    },
  },

  methods: {
    onClick(event) {
      if (!this.disabled) {
        this.$emit("click", event);
      }
    },

    onMouseEnter() {
      if (!this.title) return;

			this.$core.tooltip.show(this.$el, this.title);
    },

    onMouseLeave() {
			this.$core.tooltip.hide();
    },
  },
};
</script>
